// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__3Fc7_","placeholderShimmer":"styles_placeholderShimmer__gFn5j","defaultImageCopy":"styles_defaultImageCopy__kjVRg"};